import { createSelector } from '~/helpers/util/selectors';
import { SpecialDateCreateState } from './duck';

export const getRoot = (state: any) => {
  return state.ui.specialDateCreate as SpecialDateCreateState;
};

export const getCreateStatus = createSelector([getRoot], state => {
  return state.createStatus;
});

export const getErrorMessage = createSelector([getRoot], state => {
  return state.errorMessage;
});

export const getIsLoading = createSelector([getCreateStatus], createStatus => {
  return createStatus === 'creating';
});
